var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Logout, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logout",
    d: "M5.69774 21.2429C5.14774 21.2429 4.67691 21.0471 4.28524 20.6554C3.89357 20.2638 3.69774 19.7929 3.69774 19.2429V5.24292C3.69774 4.69292 3.89357 4.22209 4.28524 3.83042C4.67691 3.43875 5.14774 3.24292 5.69774 3.24292H12.6977V5.24292H5.69774V19.2429H12.6977V21.2429H5.69774ZM16.6977 17.2429L15.3227 15.7929L17.8727 13.2429H9.69774V11.2429H17.8727L15.3227 8.69292L16.6977 7.24292L21.6977 12.2429L16.6977 17.2429Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.6d3cc9ff484464706a062f4587259e14.svg";
export { ForwardRef as ReactComponent };